export default __webpack_public_path__ + "media/images/gallery/22-7e2ae4227c1c976b192c01ef91ea595c.jpg";